import { isMiniProgram } from '../tools/device'

const mixinsDevice = {
  data () {
    return {
      isMiniProgramModel: false
    }
  },
  mounted () {
    this.isMiniProgramModel = this.isMiniProgram()
  },
  methods: {
    isMiniProgram
  }
}

export { mixinsDevice }



// WEBPACK FOOTER //
// ./src/mixins/index.js